module.exports = __webpack_public_path__ + "static/media/simple-hamb.0b0091c7.webp";